module.exports = __webpack_public_path__ + "static/media/exit_dark_grey.9f3d2b57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/icons/exit_dark_grey.png
// module id = ./src/assets/media/icons/exit_dark_grey.png
// module chunks = 16